import { paramsToQuery } from '@/base/MaUtils.js'
import { cacheRequest } from '@/base/MaRequestPooler.js'

export function getVersionHistory({ trackId, countryCode, startDate, endDate }) {
  return cacheRequest(`/app/${trackId}/version-history/${countryCode}?${paramsToQuery({
    startDate,
    endDate,
  })}`)
}
